import Marquee from "react-fast-marquee";

const ITEMS = [
  "Nanoblading · Hairstroke · Lip Blush",
  "Tricopigmentation & Skin Repair",
  "Studio privé — Paris 17ᵉ",
  "Formations en présentiel & en ligne",
];

const Diamond = () => (
  <span className="inline-block w-1.5 h-1.5 rotate-45 bg-accent mx-10 translate-y-[-2px]" />
);

export default function Ribbon() {
  return (
    <div className="border-y border-border py-5 bg-background overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display italic text-xl md:text-2xl text-foreground/80">
              {item}
            </span>
            <Diamond />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
